import React from "react";
import { Route, Routes } from "react-router-dom";
import HomeTrainer from "../pages/HomeTrainer";
import HomeStudent from "../pages/HomeStudent";
import HomeAllTrainer from "../pages/HomeAllTrainer";

const Router = () => {
	return (
		<Routes>
			<Route path="/trainer" element={<HomeTrainer />} />
			<Route path="/student" element={<HomeStudent />} />
			<Route path="/alltrainer" element={<HomeAllTrainer />} />
		</Routes>
	);
};

export default Router;
